<div data-automation="call-queue-form" class="container h-100">
  @if (isLoading) {
    <ziro-loading-block></ziro-loading-block>
  } @else {
    @if (!this.is360ViewChild) {
      <ziro-breadcrumbs>
        <ziro-breadcrumb-card-item [aboutCardId]="105"></ziro-breadcrumb-card-item>
      </ziro-breadcrumbs>
    }

    @if (invalidResourceAccountOrAgent) {
      <div data-automation="invalid-alert" class="alert alert-warning">
        <strong>{{ 'tkey;teams_call_queue.invalid.resource_account_or_agent.warning.title' | translate }}</strong>
        <p class="mb-0">{{ 'tkey;teams_call_queue.invalid.resource_account_or_agent.warning' | translate }}</p>
      </div>
    }

    <ziro-teams-call-queue-edit-form
      [entity]="callQueueEntity"
      [callQueueViewSource]="callQueueView"
      [languageOptions]="languageOptions"
      (isQueueValid)="setInvalidResourceAccountOrAgent($event)"
    ></ziro-teams-call-queue-edit-form>
  }
</div>
